import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormValidationProvider, useFormValidation } from '../components/shared/formValidation';
import { FormShell } from '../components/workflow/FormShell';
import {
  emptyScreeningRecordForm, screeningRecordGaps, screeningRecordFormData,
  useScreeningRecordOptions, ScreeningRecordFormFields,
} from '../components/records/screeningRecordKind';
import { fetchJSON } from '../utils/api';

// Management — a manual Screening record (docs/modules/workflow-screening.md
// §記錄層): a background check done outside the Screening flow, or a legacy one.
// Same blocks as the Screening request; no review — creation is final.
const QMScreeningRecordNew = () => {
  const navigate = useNavigate();
  const { options, optionsError } = useScreeningRecordOptions();
  const [f, setF] = useState(emptyScreeningRecordForm());
  const [screeningFile, setScreeningFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setF((prev) => ({ ...prev, [k]: v }));

  const gaps = useMemo(() => screeningRecordGaps(f), [f]);
  const validation = useFormValidation(gaps);

  const submit = async () => {
    if (!validation.validate()) { setError(null); return; }
    setSaving(true); setError(null);
    try {
      const data = await fetchJSON('/api/qm/screening-records', {
        method: 'POST', body: screeningRecordFormData(f, { screeningFile, files }),
      });
      navigate(`/qm/screening-records/${data.record.id}`);
    } catch (e) { setError(e.message); setSaving(false); }
  };

  return (
    <FormShell
      backTo="/qm/screening-records"
      backLabel="Screening Records"
      title="New Screening Record"
      subtitle="Record a background check completed outside the system."
      error={error || validation.error || optionsError}
      onSubmit={submit}
      submitLabel="Create Record"
      submitting={saving}
    >
      <FormValidationProvider value={validation.providerValue}>
        <ScreeningRecordFormFields
          f={f} set={set} options={options}
          screeningFile={screeningFile} setScreeningFile={setScreeningFile}
          files={files} setFiles={setFiles}
        />
      </FormValidationProvider>
    </FormShell>
  );
};

export default QMScreeningRecordNew;
